import React from 'react'
import '../App.css'
import Bodyfinalbuy from './bodyfinalbuy'
export class Bodyappfinalbuybody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className='sshbodyapp'>
                <div className='sshbodyappContainer'>
                   <Bodyfinalbuy/>
                </div>
            </div>
        );
    }
}